import { UrlConstants } from "../url.constants";
export class ApiEhInspectionSurveyConstants {
    static URL = UrlConstants.API_V2 + "EhInspectionSurvey";
    static FUNCTION_GET = "GET";
}
